import {
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import theme from '../../../../theme/theme';
import type { SubMenuItem } from '../NavigationSideMenu.types';

interface SubMenuListProps {
  items: (SubMenuItem & { selected: boolean })[];
  isExpanded: boolean;
  onNavigate: (path?: string) => void;
  showLabel: boolean;
  variant: 'mobile' | 'desktop';
  translate: (key: string) => string;
}

export function SubMenuList({
  items,
  isExpanded,
  onNavigate,
  showLabel,
  translate,
}: SubMenuListProps) {
  return (
    <Collapse in={isExpanded} timeout="auto" unmountOnExit>
      {/* <ul> imbriqué dans le <li> parent : un <li> ne peut pas contenir directement un <li> */}
      <List disablePadding sx={{ py: 0, my: 0 }}>
        {items.map(sub => (
          <ListItem key={sub.key} disablePadding>
            <ListItemButton
              selected={sub.selected}
              onClick={() => onNavigate(sub.path)}
              aria-label={!showLabel ? translate(sub.labelKey) : undefined}
              aria-current={sub.selected ? 'page' : undefined}
              sx={{
                minHeight: theme.toolbar.height,
                pl: { xs: theme.spacing(2.5), sm: theme.spacing(2) },
                pr: { xs: theme.spacing(2.5), sm: theme.spacing(2) },
                justifyContent: showLabel ? 'initial' : 'center',
                color: theme.palette.text.label,
                borderLeft: '4px solid transparent',
                transition:
                  'background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease',
                '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
                '&:hover': {
                  bgcolor: theme.navigation.subMenu.hover,
                  color: theme.navigation.subMenu.selectedAccent,
                },
                '&:focus-visible': {
                  outline: `2px solid ${theme.navigation.subMenu.selectedBorder}`,
                  outlineOffset: '2px',
                },
                '&.Mui-selected': {
                  bgcolor: theme.navigation.subMenu.selected,
                  color: theme.navigation.subMenu.selectedAccent,
                  borderLeft: `4px solid ${theme.navigation.subMenu.selectedBorder}`,
                },
                '&.Mui-selected:hover': {
                  bgcolor: theme.navigation.subMenu.selected,
                  color: theme.navigation.subMenu.selectedAccent,
                  borderLeft: `4px solid ${theme.navigation.subMenu.selectedBorder}`,
                },
                '&:hover .MuiListItemIcon-root': {
                  color: theme.navigation.subMenu.selectedAccent,
                },
                '&.Mui-selected .MuiListItemIcon-root': {
                  color: theme.navigation.subMenu.selectedAccent,
                },
              }}
            >
              {sub.icon && (
                <ListItemIcon
                  sx={{
                    minWidth: theme.toolbar.height,
                    mr: showLabel ? 3 : 'auto',
                    justifyContent: 'center',
                    color: theme.palette.text.label,
                    flexShrink: 0,
                    transition: 'color 0.15s ease, margin 300ms cubic-bezier(0.4, 0, 0.2, 1)',
                    '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
                  }}
                >
                  {sub.icon}
                </ListItemIcon>
              )}
              {showLabel && (
                <ListItemText
                  primary={translate(sub.labelKey)}
                  sx={{
                    ml: sub.icon ? 2 : 0,
                  }}
                />
              )}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Collapse>
  );
}
